import { Skeleton } from '@factorialco/deprecated-design-system'
import { F0Box } from '@factorialco/f0-react'

const TableRowSkeleton = () => (
  <F0Box display="flex" paddingY="sm">
    <F0Box grow>
      <Skeleton height="s16" width="s120" />
    </F0Box>
    <F0Box display="flex" justifyContent="end" width="24">
      <Skeleton height="s16" width="s48" />
    </F0Box>
    <F0Box display="flex" justifyContent="end" width="16">
      <Skeleton height="s16" width="s32" />
    </F0Box>
    <F0Box display="flex" justifyContent="end" width="16">
      <Skeleton height="s16" width="s32" />
    </F0Box>
  </F0Box>
)

export const PayoutBreakdownSkeleton = () => (
  <F0Box display="flex" flexDirection="column" gap="lg">
    <F0Box display="flex" flexDirection="column">
      <F0Box display="flex" paddingY="sm">
        <F0Box grow>
          <Skeleton height="s12" width="s64" />
        </F0Box>
        <F0Box display="flex" justifyContent="end" width="24">
          <Skeleton height="s12" width="s64" />
        </F0Box>
        <F0Box display="flex" justifyContent="end" width="16">
          <Skeleton height="s12" width="s40" />
        </F0Box>
        <F0Box display="flex" justifyContent="end" width="16">
          <Skeleton height="s12" width="s40" />
        </F0Box>
      </F0Box>
      <TableRowSkeleton />
      <TableRowSkeleton />
      <TableRowSkeleton />
    </F0Box>

    <F0Box
      borderTop="default"
      borderBottom="default"
      paddingY="md"
      display="flex"
      flexDirection="column"
      gap="sm"
    >
      <F0Box display="flex" justifyContent="between" alignItems="center">
        <Skeleton height="s12" width="s120" />
        <Skeleton height="s16" width="s40" />
      </F0Box>
    </F0Box>

    <F0Box display="flex" justifyContent="between" alignItems="center">
      <Skeleton height="s16" width="s140" />
      <Skeleton height="s16" width="s64" />
    </F0Box>
  </F0Box>
)
